import React from 'react';

import './chip-header.scss';

import { IClassNames, makeClassNames } from '../../../utils/styles';
import TypographyElements from '../../foundation/typography/typography-element/typography-elements';

export interface IChipHeader {
  text: string;
  itemId: number;
  isSelected: boolean;
  isDesktop: boolean;
  appType?: string;
  onClick: (value: unknown) => void;
}

const ChipHeader: React.FC<IChipHeader> = ({ text, isSelected = false, isDesktop = false, onClick }) => {
  const classNames = (isDesktop: boolean, isSelected: boolean): IClassNames =>
    makeClassNames({
      chipHeader: ['chip-header', isDesktop && 'chip-header__desktop', isSelected && 'chip-header__selected'],
      chipHeaderText: ['chip-header__text'],
    });
  const cn = classNames(isDesktop, isSelected);

  return (
    <button type="button" aria-label={text} className={cn.chipHeader} onClick={onClick}>
      <span className={cn.chipHeaderText}>
        <TypographyElements text={text} typographyClass="ty-elements-medium" />
      </span>
    </button>
  );
};
export default ChipHeader;
